module.exports = __webpack_public_path__ + "img/brifecase-tick.f4a48482.svg";